module.exports = __webpack_public_path__ + "static/codemashdefault-9711d9fc45f1cec38337f3a35ee42151.jpeg";